<template>
    <div
      v-if="localValue.type === 'datepicker'"
      :id="'element' + index"
      class="relative"
      :style="
        'margin: ' + styles.margin.join('px ') + 'px;' +
        'color:' + styles.color + ';'
      "
    >
      <div
        class="text-sm font-semibold mb-2"
        v-if="!hideLabels"
        :style="
          'text-align: ' + styles.text.textAlign + ';' +
          'color: ' + styles.labelColor + ';'
        "
      >
        {{ localValue.placeholder }}
        <span
          v-if="
          localValue.mandatory === true ||
          localValue.mandatory === 1 ||
          localValue.mandatory === 'true'
          "
          style="color: red; font-weight: bold"
          >*</span
        >
      </div>
      <div
        class="
          w-full relative border border-solid rounded-lg text-dark flex
          text-sm border-none text-grey-600 border-grey-200
        "
      >
        <div
          class="absolute z-50 pointer-events-none"
          style="right: 15px; top: 50%; transform: translateY(-50%);"
        >
          <CalenderIcon class="text-grey-500 h-5 w-5"/>
        </div>
        <DateTimePicker
          class="px-0 h-full"
          variant="custom"
          picker="date"
          :maxDatetime="new Date().toISOString()"
          v-model="localValue.value"
          :placeholder="localValue.placeholder"
          @focusin="emitClicked"
          :inputStyle="
            'background:' + styles.backgroundColor + ';' +
            'box-shadow:' + (styles.boxShadow ?? '') + ';' +
            'padding: ' + styles.padding.join('px ') + 'px;' +
            'height:auto;' +

            '--form-style-placeholder-color:' + styles.placeholderColor + ';' +
            'font-family:' + (styles.text.fontFamily || '') + ';' +
            'text-shadow:' + (styles.text.textShadow || '') + ';' +
            'font-size:' + styles.text.fontSize + 'px;' +
            'text-align:' + styles.text.textAlign + ';' +
            'font-style:' + (styles.text.fontStyle || '') + ';' +
            'font-weight:' + (styles.text.fontWeight || '') + ';' +
            'letter-spacing:' + (styles.text.letterSpacing || '') + ';' +
            'line-height:' + (styles.text.lineHeight || '') + ';' +
            '-webkit-text-stroke-width:' + (styles.text.textStrokeWidth || '') + ';' +
            '-webkit-text-stroke-color:' + (styles.text.textStrokeColor || '') + ';' +
            'text-decoration-line:' + (styles.text.textDecorationLine || '') + ';' +
            'color:' + styles.text.color + ';' +

            'border-width:' + styles.border?.width.join('px ') + 'px;' +
            'border-radius:' + styles.border?.radius.join('px ') + 'px;' +
            'border-color:' + styles.border?.color.join(' ') + ';' +
            'border-style:' + styles.border?.style.join(' ') + ';' +
            styles.customStyles ?? ''
          "
        />
      </div>
    </div>
  </template>
  <script>
  import { mapState } from 'vuex';
  
  import DateTimePicker from '@groovepages/gd-ui-kit/components/DateTimePicker';
  // import icons
  import CalenderIcon from '@/assets/images/icons/new/calendar_days_new.svg';
  
  export default {
    name: 'FormTextBox',
    props: {
      value: {
        required: true,
      },
      index: {
        required: true,
      },
      styles: {
        required: true,
      },
    },
    components: {
      DateTimePicker,
      CalenderIcon,
    },
    computed: {
      ...mapState({
        hideLabels: state => state.forms.hideLabels,
      }),
      localValue: {
        get: function () {
          return this.value;
        },
        set: function (val) {
          this.$emit('input', val);
        }
      }
    },
    methods: {
      emitClicked() {
        this.$emit('clicked');
      }
    }
  };
  </script>